<template>
  <div class="text-media critical-component-clear">
    <div class="text-media__container container">
      <div class="text-media__content rte">
        <div
          v-if="settings.subheading"
          class="
            text-media__subheading
            text-other-button-l
            text-other-label-l-desktop
          "
          v-text="settings.subheading"
        />

        <div
          v-if="settings.title"
          class="
            text-media__title
            text-heading-xl
            text-heading-5xl-desktop
          "
          v-text="settings.title"
        />

        <div
          v-if="settings.text"
          class="text-media__text"
          :class="[settings.textSizeMobile, settings.textSizeDesktop]"
          v-html="settings.text"
        />

        <div
          v-if="blocks.length"
          class="text-media__cta-wrapper"
        >
          <template
            v-for="(block, index) of blocks"
            :key="index"
          >
            <btn
              v-if="block.text && block.link"
              class="text-media__cta"
              custom-element="a"
              :label="block.text"
              :url="block.link"
              :modifiers="modifiers"
            />
          </template>
        </div>
      </div>

      <div
        v-if="settings.image || settings.video"
        class="text-media__media"
      >
        <responsive-image
          v-if="settings.mediaType === 'image' && settings.image"
          :image="settings.image"
          :ratio="0.75"
        />
        <video-player
          v-else-if="settings.mediaType === 'video' && settings.video"
          class="text-image__video-player"
          :image="settings.video.preview_image"
          :video="getMp4Source(settings.video)?.[0]"
          :has-audio-control="settings.soundControl"
          is-active
        />
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Text Media (text-media)
 * -----------------------------------------------------------------------------
 * Global section that has text, CTAs and an option to add an image or video.
 *
 * @param {Object} settings - Section settings.
 * @param {Array} blocks - Section blocks.
 *
 */
import Btn from '~global/btn/btn'
import ResponsiveImage from '~global/images/responsive-image'
import VideoPlayer from '~async/video-player/video-player'

export default {
  name: 'TextMedia',

  components: {
    Btn,
    ResponsiveImage,
    VideoPlayer,
  },

  props: {
    settings: {
      type: Object,
      default: () => ({
        subheading: '',
        title: '',
        text: '',
        textSizeMobile: '',
        textSizeDesktop: '',
        theme: '',
        mediaType: '',
        soundControl: false,
        image: {},
        video: {},
      }),
    },
    blocks: {
      type: Array,
      default: () => [],
    },
  },

  computed: {

    /**
     * Returns button modifiers.
     * @returns {String}
     */
    modifiers() {
      if (this.settings.theme === 'dark') {
        return 'primary center dark'
      }

      return 'primary center'
    },
  },

  methods: {

    /**
     * Returns the highest resolution mp4 video source from the supplied video.
     * @param {Object} video - Shopify video object.
     * @returns {Array}
     */
    getMp4Source(video) {
      const sources = [...video.sources.filter(source => source.format === 'mp4')]
      return sources.sort((a, b) => b.width - a.width)
    },
  },
}
</script>

<style lang="scss">
@import './text-media';
</style>
